<template>
  <div>
  <b-alert v-if="tenantError" show variant="danger" role="alert">{{ tenantError }}</b-alert>
  <p v-if="tenantMode && !documentReady && !tenantError" role="status">Loading verified LOI...</p>
  <div v-if="!tenantMode || (issuingTenant && documentReady && !tenantError)">
  <b-container v-if="processdate(LOI.LOIDate) < processdate('01/01/2025')">
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print" :disabled="tenantMode && !letterheadReady">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
            >
              <img style="width:140px;margin-top:10px;" :src="headerImage" @load="letterheadReady=true" @error="onLetterheadError" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                <span
                  style="font-size:15.0pt;font-weight:bold;"
                >{{ documentBranding.NameMarathi }}</span>
                <br />
                <span
                  style="font-size:14.0pt;font-weight:bold;font-style:italic;"
                  v-if="subDepartmentName"
                >{{subDepartmentName}}</span>
                <br v-if="subDepartmentName" />
                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >{{ documentBranding.AddressMarathi }}</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी क्र.</span>
              <span style="font-size:11.0pt;font-weight:normal;"> {{ documentBranding.Phone }}</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">{{ documentBranding.WebsiteUrl }}/</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span>{{ documentBranding.Email }}
              </span>
            </td>
          </tr>
        </table>
        <span style="font-size:8pt;float:right">{{ documentBranding.Cin }}</span>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==1 || effectiveLoanType== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==2 || effectiveLoanType=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==3 || effectiveLoanType== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (effectiveLoanType==1 || effectiveLoanType==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="effectiveLoanType==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (effectiveLoanType==1 || effectiveLoanType==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{applicantDisplayName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="effectiveLoanType==1 || effectiveLoanType==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="effectiveLoanType==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपणास कळविण्यात येते की महामंडळाच्या
              <span v-if="effectiveLoanType==2 || effectiveLoanType=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="effectiveLoanType==1 || effectiveLoanType=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="effectiveLoanType==3 || effectiveLoanType=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:11.0pt;" v-if="effectiveLoanType==1 || effectiveLoanType=='1'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, आपण निवडत असलेल्या या {{displayBusinessName}} उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणास हे प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे;
            </span>
            <span style="font-size:11.0pt;" v-if="effectiveLoanType==2 || effectiveLoanType=='2'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, आपण निवडत असलेल्या या {{displayBusinessName}} उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणास हे प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे;
            </span>
            <span style="font-size:11.0pt;" v-if="effectiveLoanType==3 || effectiveLoanType=='3'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, {{displayBusinessName}} या अभ्यासक्रमासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी, आपणास हे हेतु प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="display: block; margin-left:50%;text-align:center; align-items:right">
            <span style="font-weight:bold;font-size:12.0pt">Sd/-</span>


            <br />
            <span style="font-size:12.0pt;">महाव्यवस्थापक</span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="tenantMode || LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >{{ documentBranding.NameMarathi }}</span>
            <span
              style="font-size:12.0pt;" v-if="!tenantMode && LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span>
            <br v-if="subDepartmentName" />
            <span
              style="font-size:11.0pt;font-style:italic;"
              v-if="subDepartmentName"
            >{{subDepartmentName}}</span>
            <br />
          </div>

          <div style="margin-top: 15px; margin-bottom: 10px;" v-if="effectiveLoanType==1 || effectiveLoanType=='1'">
            <p
              style="font-size:12.0pt;font-weight:bold;text-align:center;margin-bottom: 10px;"
            >महामंडळाच्या अटी व शर्ती</p>
            <p style="margin-bottom: 1px; font-size:10.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==2 || effectiveLoanType=='2'">
           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==3 || effectiveLoanType=='3'">
            <p
              style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
            >महामंडळाच्या अटी व शर्ती</p>

           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
            <span style="font-weight:bold;font-size:12pt">Sd/-</span>
            <br />
            <span style="font-size:12.0pt">महाव्यवस्थापक </span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="tenantMode || LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >{{ tenantMode ? documentBranding.NameMarathi : 'वसंतराव नाईक विमुक्त जाती व भटक्या जमाती विकास महामंडळ मर्यादित' }}</span>
            <span
              style="font-size:12.0pt;" v-if="!tenantMode && LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span>
            <br v-if="subDepartmentName" />
            <span
              style="font-size:11.0pt;font-style:italic;"
              v-if="subDepartmentName"
            >{{subDepartmentName}}</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

  <b-container v-else-if="processdate(LOI.LOIDate) >= processdate('01/01/2025') && processdate(LOI.LOIDate) < processdate('21/04/2025')">
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print" :disabled="tenantMode && !letterheadReady">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
            >
              <img style="width:140px;margin-top:10px;" :src="headerImage" @load="letterheadReady=true" @error="onLetterheadError" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                <span
                  style="font-size:17.0pt;font-weight:bold;"
                >{{ documentBranding.NameMarathi }}</span>
                <br />
                <span
                  style="font-size:15.0pt;font-weight:bold;font-style:italic;"
                  v-if="subDepartmentName"
                >{{subDepartmentName}}</span>
                <br v-if="subDepartmentName" />
                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >{{ documentBranding.AddressMarathi }}</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
              <span style="font-size:11.0pt;font-weight:normal;"> {{ documentBranding.Phone }}</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">{{ documentBranding.WebsiteUrl }}/</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span> {{ documentBranding.Email }} <br/>
                 <span style="font-size:8pt;float:right">{{ documentBranding.Cin }}</span>
              </span>
            </td>
          </tr>
        </table>

          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==1 || effectiveLoanType== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==2 || effectiveLoanType=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==3 || effectiveLoanType== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (effectiveLoanType==1 || effectiveLoanType==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="effectiveLoanType==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (effectiveLoanType==1 || effectiveLoanType==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{applicantDisplayName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="effectiveLoanType==1 || effectiveLoanType==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="effectiveLoanType==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपण, महामंडळाच्या
              <span v-if="effectiveLoanType==2 || effectiveLoanType=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="effectiveLoanType==1 || effectiveLoanType=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="effectiveLoanType==3 || effectiveLoanType=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="effectiveLoanType==1 || effectiveLoanType=='1'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{displayBusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="effectiveLoanType==2 || effectiveLoanType=='2'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{displayBusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="effectiveLoanType==3 || effectiveLoanType=='3'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या  {{displayBusinessName}} या अभ्यासक्रमासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==1 || effectiveLoanType=='1'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==2 || effectiveLoanType=='2'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==3 || effectiveLoanType=='3'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
          <!-- <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/> -->
            <span style="font-weight:bold;font-size:12pt">Sd/-</span>
            <br />
            <span style="font-size:12.0pt">{{ this.loidesignationlabel }}</span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="tenantMode || LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >{{ documentBranding.NameMarathi }}</span>

            <br v-if="subDepartmentName" />
            <span
              style="font-size:11.0pt;font-style:italic;"
              v-if="subDepartmentName"
            >{{subDepartmentName}}</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

  <b-container v-else>
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print" :disabled="tenantMode && !letterheadReady">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
            >
              <img style="width:140px;margin-top:10px;" :src="headerImage" @load="letterheadReady=true" @error="onLetterheadError" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                <span
                  style="font-size:17.0pt;font-weight:bold;"
                >{{ documentBranding.NameMarathi }}</span>
                <br />
                <span
                  style="font-size:13.0pt;font-weight:bold;font-style:italic;"
                  v-if="subDepartmentName"
                >{{subDepartmentName}}</span>
                <br v-if="subDepartmentName" />
                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >{{ documentBranding.AddressMarathi }}</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
              <span style="font-size:11.0pt;font-weight:normal;"> {{ documentBranding.Phone }}</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">{{ documentBranding.WebsiteUrl }}/</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span> {{ documentBranding.Email }} <br/>
                  <span style="font-size:8pt;float:right">{{ documentBranding.Cin }}</span>
              </span>
            </td>
          </tr>
        </table>

          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==1 || effectiveLoanType== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==2 || effectiveLoanType=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="effectiveLoanType==3 || effectiveLoanType== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (effectiveLoanType==1 || effectiveLoanType==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="effectiveLoanType==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (effectiveLoanType==1 || effectiveLoanType==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{applicantDisplayName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="effectiveLoanType==1 || effectiveLoanType==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="effectiveLoanType==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपण, महामंडळाच्या
              <span v-if="effectiveLoanType==2 || effectiveLoanType=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="effectiveLoanType==1 || effectiveLoanType=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="effectiveLoanType==3 || effectiveLoanType=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="effectiveLoanType==1 || effectiveLoanType=='1'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{displayBusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="effectiveLoanType==2 || effectiveLoanType=='2'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{displayBusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="effectiveLoanType==3 || effectiveLoanType=='3'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या  {{displayBusinessName}} या अभ्यासक्रमासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedLOIAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==1 || effectiveLoanType=='1'">


          <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==2 || effectiveLoanType=='2'">


         <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="effectiveLoanType==3 || effectiveLoanType=='3'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
          <!-- <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/> -->
            <!-- <span style="font-weight:bold;font-size:12pt">Sd/-</span> -->
            <br>
            <span style="font-size:12.0pt" v-if="shouldShowAnandLomteName">Sd/-</span>
            <br v-if="shouldShowAnandLomteName" />
            <span style="font-size:12.0pt">महाव्यवस्थापक </span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="tenantMode || LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >{{ documentBranding.NameMarathi }}</span>
            <span
              style="font-size:12.0pt;" v-if="!tenantMode && LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span>
            <br v-if="subDepartmentName" />
            <span
              style="font-size:11.0pt;font-style:italic;"
              v-if="subDepartmentName"
            >{{subDepartmentName}}</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

  </div>
  </div>
</template>

<script>import { protectedDocumentUrl } from "@/services/tenantDocuments";

import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
import { validateBranding, verificationUrl } from "@/services/tenant";
import { LEGACY_BRANDING } from "@/services/portalBranding";

export default {
  props: ["ApplicationID", "Loantype", "UserID", "PastLOI"],
  data() {
    return {
      issuingTenant: null,
      documentReady: false,
      letterheadReady: false,
      tenantError: "",
      brandingRequest: 0,
      LOI: {
        LoanApplicationNo: "",
        ApplicationDate: "",
        ApplicantName: "",
        AdharNo: "",
        Address: "",
        LOIDate: "",
        LOINumber: "",
        BusinessName: "",
        Division: "",
        LOIValidTill: "",
        IsExtended: false,
        LoanAmount: 0,
        CasteName: "",
        Caste: "",
        CasteID: ""
      },
      isLoading: false,
      alertText: "",
      showDismissibleAlert: true,
      variant: "danger",
      qrtext: "this is error",
      size: 100,
      loidesignationlabel: "",
      userCasteName: "",
      casteList: [],
      debugLOIRaw: "",
      debugLOIKeys: ""
    };
  },
  computed: {
    documentBranding() {
      return this.tenantMode ? this.issuingTenant : LEGACY_BRANDING;
    },
    headerImage() {
      return this.documentBranding ? this.documentBranding.LogoUrl : "";
    },
    effectiveApplicationID() {
      return this.ApplicationID || this.$route.params.ApplicationID || this.$route.query.ApplicationID || "";
    },
    effectiveLoanType() {
      if (this.tenantMode) return this.LOI.LoanType;
      return this.Loantype || this.$route.params.Loantype || this.$route.query.Loantype || "";
    },
    effectiveUserID() {
      return this.UserID || this.$route.params.UserID || this.$route.query.UserID || "";
    },
    effectivePastLOI() {
      const routeValue = this.PastLOI || this.$route.params.PastLOI || this.$route.query.PastLOI;
      return routeValue === true || routeValue === "true" || routeValue === 1 || routeValue === "1";
    },
    shouldShowAnandLomteName() {
      if (!this.LOI.LOIDate) return false;
      const loiDateTime = this.processdate(this.LOI.LOIDate);
      const cutoffDateTime = this.processdate('05/09/2025'); // September 5, 2025
      return loiDateTime >= cutoffDateTime;
    },
    displayBusinessName() {
      // Some LOI records store the value as "BANK NAME (ACTUAL BUSINESS NAME)" -
      // only the parenthesized part should ever be shown on the printed LOI.
      const raw = this.LOI.BusinessName;
      if (!raw || typeof raw !== "string") return raw;
      const match = raw.trim().match(/^.*\(([^()]+)\)\s*$/);
      return match ? match[1].trim() : raw.trim();
    },
    applicantDisplayName() {
      // Primary: ApplicantName
      if (this.LOI.ApplicantName && this.LOI.ApplicantName.trim()) {
        return this.LOI.ApplicantName.trim();
      }
      // Fallback 1: Name field
      if (this.LOI.Name && this.LOI.Name.trim()) {
        return this.LOI.Name.trim();
      }
      // Fallback 2: Construct from FirstName + MiddleName + LastName
      const parts = [
        this.LOI.FirstName,
        this.LOI.MiddleName,
        this.LOI.LastName
      ].filter(p => p && p.trim());
      if (parts.length > 0) {
        return parts.join(' ');
      }
      // Fallback 3: GroupName (for group loans)
      if (this.LOI.GroupName && this.LOI.GroupName.trim()) {
        return this.LOI.GroupName.trim();
      }
      // Fallback 4: FullName
      if (this.LOI.FullName && this.LOI.FullName.trim()) {
        return this.LOI.FullName.trim();
      }
      return '';
    },
    subDepartmentName() {
      if (this.tenantMode) return '';
      const normalize = s => s ? s.normalize('NFC').toLowerCase().trim() : '';
      // Strip all Devanagari combining marks for fuzzy comparison
      const stripMarks = s => s.replace(/[\u094D\u093E-\u094C\u0962\u0963]/g, '');

      // First try: look up exact CasteName from the getCaste() list using CasteID
      let dbCasteName = '';
      if (this.LOI.CasteID && this.casteList && this.casteList.length > 0) {
        const found = this.casteList.find(c => c.CasteID === this.LOI.CasteID);
        if (found) dbCasteName = found.CasteName || '';
      }

      const raw = normalize(
        dbCasteName ||
        this.userCasteName ||
        this.LOI.CasteName ||
        this.LOI.Caste ||
        this.LOI.casteName ||
        this.LOI.caste ||
        this.LOI.UserCaste ||
        this.LOI.Category ||
        this.LOI.SubCaste ||
        ''
      );
      if (!raw) return '';

      // Remove category prefix like "VJ-A ", "NT-B ", "OBC ", "SBC " etc. if present
      // e.g. "vj-a गाडी वड्डर" → "गाडी वड्डर"
      const rawClean = raw.replace(/^[a-z0-9]+[-–]?[a-z0-9]*\s+/i, '').trim();
      console.log('subDepartmentName: CasteID=', this.LOI.CasteID, 'dbCasteName=', dbCasteName, 'userCasteName=', this.userCasteName, 'raw=', raw, 'rawClean=', rawClean);

      const subDepts = [
        {
          name: 'राजे उमाजी नाईक आर्थिक विकास महामंडळ',
          castes: ['रामोशी']
        },
        {
          name: 'पैलवान कै. मारुती चव्हाण-वडार आर्थिक विकास महामंडळ',
          castes: ['वडार', 'वड्डर', 'वड्डार', 'गाडी वड्डर', 'माती वड्डर', 'जाती वड्डर', 'पाथरवट', 'संगतराश', 'दगडफोडू', 'गाडी वडार', 'माती वडार', 'जाती वडार']
        },
        {
          name: 'ब्रम्हलिन आचार्य दिव्यानंद पुरीजी महाराज आर्थिक विकास महामंडळ',
          castes: ['लोहार', 'घिसाडी', 'गाडी लोहार', 'चितोडी लोहार', 'रजपूत लोहार', 'पांचाळ लोहार', 'खाती', 'खातवाढी', 'चितारी', 'जिनगर']
        },
        {
          name: 'श्रीकृष्ण आर्थिक विकास महामंडळ',
          castes: ['गवळी', 'गवलान', 'ग्वालवंश', 'गोपाल-गवळी', 'गवळी-गोपाल', 'मुस्लीम गवळी']
        },
        {
          name: 'विणकर समाज आर्थिक विकास महामंडळ',
          castes: ['कोष्टी', 'साळी', 'स्वकुळ साळी', 'लाडकोष्टी', 'गढेवाल कोष्टी', 'देशकर', 'पद्म शाली', 'देवांग', 'जैनकोष्टी', 'लिंगायत कोष्टी', 'लिंगायत देवांग', 'लिंगायत साळी', 'विणकर']
        },
        {
          name: 'परमपुज्य गंगानाथ महाराज आर्थिक विकास महामंडळ',
          castes: ['गोसावी', 'भराडी', 'गुसाई', 'गोसाई', 'नाथपंथी', 'बावा', 'बैरागी', 'भारती गोसावी', 'नाथ जोगी', 'जोगी', 'डवरी']
        }
      ];
      // Exact match first
      for (const dept of subDepts) {
        for (const caste of dept.castes) {
          const c = normalize(caste);
          if (raw.includes(c) || rawClean.includes(c) || c.includes(rawClean) || raw === c || rawClean === c) {
            return dept.name;
          }
        }
      }
      // Fuzzy match by stripping Devanagari combining marks
      const rawStripped = stripMarks(rawClean);
      for (const dept of subDepts) {
        for (const caste of dept.castes) {
          const cStripped = stripMarks(normalize(caste));
          if (rawStripped.includes(cStripped) || cStripped.includes(rawStripped)) {
            return dept.name;
          }
        }
      }
      console.log('subDepartmentName: NO MATCH for raw="' + raw + '" rawClean="' + rawClean + '"');
      return '';
    }
  },
  methods: {
    onLetterheadError() {
      if (this.tenantMode) {
        this.letterheadReady = false;
        this.tenantError = "The issuing corporation's configured letterhead logo is unavailable. Printing is blocked.";
      }
    },
    print() {
      if (this.tenantMode && (!this.issuingTenant || !this.documentReady || !this.letterheadReady || this.tenantError)) {
        this.tenantError = "The application's issuing tenant must be verified before printing.";
        return;
      }
      this.$htmlToPaper("printLOI");
    },
    parseApiBody(body) {
      if (typeof body !== "string") {
        return body;
      }
      try {
        return JSON.parse(body);
      } catch (error) {
        return body;
      }
    },
    buildGroupAddress(profile) {
      return [
        profile.GroupRegisteredAddress,
        profile.Address,
        profile.TalukaName,
        profile.DistrictName,
        profile.StateName
      ]
        .filter(value => value && String(value).trim())
        .join(", ");
    },
    applyLoiFallbacks(fallbacks) {
      Object.keys(fallbacks).forEach(key => {
        const value = fallbacks[key];
        if (value === null || value === undefined) {
          return;
        }

        const currentValue = this.LOI[key];
        const hasCurrentString = typeof currentValue === "string" && currentValue.trim();
        const hasCurrentValue = hasCurrentString || (currentValue !== null && currentValue !== undefined && currentValue !== "");

        if (!hasCurrentValue) {
          this.$set(this.LOI, key, value);
        }
      });
    },
    isValidGuid(id) {
      if (!id) return false;
      const s = String(id).trim();
      if (!s) return false;
      const emptyGuid = '00000000-0000-0000-0000-000000000000';
      return s !== emptyGuid;
    },
    getGroupUserID() {
      // Try multiple sources for a valid UserID for group loans
      const candidates = [
        this.LOI.UserID,
        this.LOI.UserId,
        this.LOI.userID,
        this.LOI.userid,
        this.LOI.CreatedBy,
        this.LOI.LoginID,
        this.LOI.loginID,
        this.effectiveUserID
      ];
      for (const id of candidates) {
        if (this.isValidGuid(id)) return String(id).trim();
      }
      // Try logged-in user from store as last resort
      if (this.$store && this.$store.getters && this.$store.getters.loggedUser) {
        const storeUID = this.$store.getters.loggedUser.UserId || this.$store.getters.loggedUser.UserID || '';
        if (this.isValidGuid(storeUID)) return String(storeUID).trim();
      }
      return null;
    },
    applyGroupProfile(profile) {
      if (!profile) return;
      const groupName = profile.GroupName || profile.groupName || profile.Aborerganization || '';
      const fullName = [profile.FirstName, profile.MiddleName, profile.LastName]
        .filter(part => part && String(part).trim()).join(' ');
      this.applyLoiFallbacks({
        ApplicantName: groupName || fullName,
        GroupName: groupName,
        FullName: fullName,
        Name: groupName,
        AdharNo: profile.GroupPAN || profile.PanCardNo || profile.PANNo || profile.PanNo,
        Address: this.buildGroupAddress(profile),
        BusinessName: profile.BusinessName || profile.businessName || profile.Business,
        LoanAmount: profile.AmountFromBank || profile.LoanAmount || profile.SanctionAmount || profile.ApprovedAmount,
        CasteID: profile.CasteID,
        CasteName: profile.CasteName,
        UserID: profile.UserID || profile.UserId,
        PhotoPath: profile.PhotoPath,
        LoanApplicationNo: profile.LoanApplicationNo || profile.ApplicationNo,
        LOINumber: profile.LOINumber || profile.LOINo || profile.LoiNumber || profile.LoiNo
          || profile.LetterOfIntentNumber || profile.LetterOfIntentNo
          || profile.LetterNumber || profile.LetterNo
          || profile.CertificateNo || profile.CertificateNumber
          || profile.EligibilityCertificateNo || profile.EligibilityCertificateNumber,
        LOIDate: profile.LOIDate || profile.LoiDate || profile.LetterDate
          || profile.IssueDate || profile.ApprovedDate || profile.ApprovalDate
          || profile.CreatedDate || profile.CreateDate || profile.Createdate
          || profile.GeneratedDate || profile.GenerateDate,
        LOIValidTill: profile.LOIValidTill || profile.LoiValidTill || profile.ValidTill || profile.ExpiryDate,
        IsExtended: profile.IsExtended,
        Division: profile.Division || profile.DivisionName,
        Gender: profile.Gender
      });
    },
    fetchGroupProfileByUID(groupUID) {
      // Try both ReadGroupProfile and ReadUserDetailByGroup in parallel
      const p1 = apis.ReadGroupProfile(groupUID)
        .then(res => {
          if (res.status !== 200) return null;
          const body = this.parseApiBody(res.body) || {};
          const profile = body.Table && body.Table.length > 0 ? body.Table[0]
            : (body.table && body.table.length > 0 ? body.table[0] : null);
          console.log('ReadGroupProfile result:', profile ? Object.keys(profile) : 'null');
          return profile;
        })
        .catch(error => {
          console.log('ReadGroupProfile error:', error);
          return null;
        });

      const p2 = apis.ReadUserDetailByGroup(groupUID)
        .then(res => {
          if (res.status !== 200) return null;
          const body = this.parseApiBody(res.body) || {};
          const profile = body.Table && body.Table.length > 0
            ? body.Table[0]
            : (body.table && body.table.length > 0 ? body.table[0]
              : (Array.isArray(body) && body.length > 0 ? body[0] : body));
          console.log('ReadUserDetailByGroup result:', profile ? Object.keys(profile) : 'null');
          return profile;
        })
        .catch(error => {
          console.log('ReadUserDetailByGroup error:', error);
          return null;
        });

      return Promise.all([p1, p2]).then(([profileFromGroup, profileFromDetail]) => {
        if (profileFromGroup) {
          this.applyGroupProfile(profileFromGroup);
        }
        if (profileFromDetail) {
          this.applyGroupProfile(profileFromDetail);
        }
        console.log('Group LOI after merge:', {
          ApplicantName: this.LOI.ApplicantName,
          AdharNo: this.LOI.AdharNo,
          Address: this.LOI.Address,
          BusinessName: this.LOI.BusinessName,
          LoanAmount: this.LOI.LoanAmount
        });
      });
    },
    loadGroupLoiDetails() {
      if (String(this.effectiveLoanType) !== '2') {
        return Promise.resolve();
      }

      const groupUID = this.getGroupUserID();
      console.log('loadGroupLoiDetails: resolved groupUID =', groupUID);

      if (groupUID) {
        return this.fetchGroupProfileByUID(groupUID);
      }

      // No valid UserID found - try to get it from ReadApprovalRemarksLink using ApplicationID
      console.log('loadGroupLoiDetails: No direct UserID, trying ReadApprovalRemarksLink...');
      return apis.ReadApprovalRemarksLink(this.effectiveApplicationID)
        .then(res => {
          if (res.status !== 200) return null;
          const body = this.parseApiBody(res.body) || {};
          const remarks = body.Table && body.Table.length > 0 ? body.Table
            : (Array.isArray(body) ? body : []);
          console.log('ReadApprovalRemarksLink result count:', remarks.length);
          // Find a valid UserID from any remark entry
          for (const r of remarks) {
            const uid = r.UserID || r.UserId || r.LoginID || r.CreatedBy || '';
            if (this.isValidGuid(uid)) {
              console.log('Found UserID from ApprovalRemarks:', uid);
              return this.fetchGroupProfileByUID(String(uid).trim());
            }
          }
          console.log('No UserID found in ApprovalRemarks either');
          return null;
        })
        .catch(error => {
          console.log('ReadApprovalRemarksLink error:', error);
          return null;
        });
    },
    getImgUrl(pic) {
      if (pic) {
        return protectedDocumentUrl(`https://aws.msobcfdc.in/S3BucketApril/${this.effectiveUserID}/${pic}`);
      }
    },
    processdate(date) {
      if (!date) return 0;
      if (this.tenantMode) {
        const value = String(date).trim();
        const numeric = value.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
        const sqlDate = value.match(/^(\d{1,2}) ([A-Za-z]{3}) (\d{4})$/);
        const isoDate = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
        const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
          'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        let year;
        let month;
        let day;
        if (numeric) {
          day = Number(numeric[1]);
          month = Number(numeric[2]) - 1;
          year = Number(numeric[3]);
        } else if (sqlDate) {
          day = Number(sqlDate[1]);
          month = months.indexOf(sqlDate[2].toLowerCase());
          year = Number(sqlDate[3]);
        } else if (isoDate) {
          year = Number(isoDate[1]);
          month = Number(isoDate[2]) - 1;
          day = Number(isoDate[3]);
        } else {
          throw new Error("The issued LOI has an unsupported date format.");
        }
        const parsed = new Date(year, month, day);
        if (parsed.getFullYear() !== year || parsed.getMonth() !== month || parsed.getDate() !== day) {
          throw new Error("The issued LOI has an invalid date.");
        }
        return parsed.getTime();
      }
      const parts = date.includes("/") ? date.split("/") : date.split("-");
      const formattedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      return formattedDate.getTime();
    },
    loadData() {
      if (!this.tenantMode) {
        this.loadLoiData();
        return;
      }
      this.issuingTenant = null;
      this.documentReady = false;
      this.letterheadReady = false;
      this.tenantError = "";
      this.LOI = {};
      const request = ++this.brandingRequest;
      const loiNumber = this.$route.params.LOINumber || "";
      apis.applicationBranding(this.effectiveApplicationID, loiNumber)
        .then(response => {
          if (request !== this.brandingRequest) return;
          this.issuingTenant = validateBranding(response.body);
          this.loadLoiData();
        })
        .catch(error => {
          if (request !== this.brandingRequest) return;
          console.error("Application tenant lookup failed:", error);
          this.tenantError = "Unable to verify the application's issuing corporation. " +
            (error.body && error.body.message ? error.body.message : error.message || "Please contact support.");
        });
    },
    loadLoiData() {
      if (!this.effectiveApplicationID) {
        return;
      }

    // For group loans: start group-profile hydration IMMEDIATELY and independently
    // of ReadLOI, so M/S name, PAN, address, LOI #, etc. populate even if
    // ReadLOI returns empty/404 for this application.
    const isGroupLoanEarly = String(this.effectiveLoanType) === '2';
    if (isGroupLoanEarly && !this.tenantMode) {
      this.loadGroupLoiDetails().catch(e => console.log('early loadGroupLoiDetails error:', e));
    }

    const applicationId = this.effectiveApplicationID;
    const brandingRequest = this.brandingRequest;
    let promiseU = this.effectivePastLOI ? apis.ReadPastLOI(applicationId) :
      apis.ReadLOI(applicationId, this.$route.params.LOINumber);

    promiseU
      .then(response => {
        if (this.tenantMode && brandingRequest !== this.brandingRequest) return;
        if (this.tenantMode && response.status !== 200) {
          throw new Error("The API did not return an issued LOI.");
        }
        if (response.status === 200) {
          const rawData = this.parseApiBody(response.body);
          console.log('ReadLOI raw response:', JSON.stringify(rawData).substring(0, 1000));
          console.log('ReadLOI raw keys:', rawData ? Object.keys(rawData) : 'null');

          // Capture raw payload for on-page debug banner
          try {
            this.debugLOIRaw = JSON.stringify(rawData);
          } catch (e) {
            this.debugLOIRaw = String(rawData);
          }

          // Extract the actual LOI record from various possible response formats
          let loiData = rawData;
          if (rawData && rawData.Table && Array.isArray(rawData.Table) && rawData.Table.length > 0) {
            loiData = rawData.Table[0];
            console.log('Extracted LOI from Table[0]');
          } else if (rawData && rawData.table && Array.isArray(rawData.table) && rawData.table.length > 0) {
            loiData = rawData.table[0];
            console.log('Extracted LOI from table[0]');
          } else if (Array.isArray(rawData) && rawData.length > 0) {
            loiData = rawData[0];
            console.log('Extracted LOI from array[0]');
          }

          // MERGE instead of replace so data already populated by the early
          // loadGroupLoiDetails() (for group loans) is preserved. Also fall
          // back to the logged-in user's UserID if LOI row doesn't carry one.
          if (loiData && typeof loiData === 'object') {
            Object.keys(loiData).forEach(k => {
              const v = loiData[k];
              if (v !== null && v !== undefined && v !== '') {
                this.$set(this.LOI, k, v);
              }
            });
          }
          // Ensure CasteID is reactive
          if (loiData && loiData.CasteID) {
            this.$set(this.LOI, 'CasteID', loiData.CasteID);
          }
          // Capture extracted-row keys for on-page debug banner
          this.debugLOIKeys = loiData && typeof loiData === 'object'
            ? Object.keys(loiData).join(', ')
            : '(no extracted row)';
          console.log('LOI Keys:', Object.keys(this.LOI));
          console.log('Caste fields:', {
            CasteID: this.LOI.CasteID,
            CasteName: this.LOI.CasteName,
            Caste: this.LOI.Caste,
            casteName: this.LOI.casteName,
            caste: this.LOI.caste,
            UserCaste: this.LOI.UserCaste,
            CasteNameMarathi: this.LOI.CasteNameMarathi,
            CasteEnglish: this.LOI.CasteEnglish,
            Category: this.LOI.Category,
            SubCaste: this.LOI.SubCaste
          });

          // Immediately set userCasteName from LOI data if available
          const immediaCaste = this.LOI.CasteName || this.LOI.Caste || this.LOI.casteName || this.LOI.caste || this.LOI.UserCaste || this.LOI.SubCaste || '';
          if (immediaCaste) {
            this.userCasteName = immediaCaste.normalize ? immediaCaste.normalize('NFC') : immediaCaste;
            console.log('Immediate userCasteName from LOI:', this.userCasteName);
          }

          // Resolve LOINumber / LOIDate from alternative field names that the
          // API may return for group loans.
          const resolvedLOINumber = this.LOI.LOINumber
            || this.LOI.LOINo
            || this.LOI.LoiNumber
            || this.LOI.LoiNo
            || this.LOI.LetterOfIntentNumber
            || this.LOI.LetterOfIntentNo
            || this.LOI.LetterNumber
            || this.LOI.LetterNo
            || this.LOI.CertificateNo
            || this.LOI.CertificateNumber
            || this.LOI.EligibilityCertificateNo
            || this.LOI.EligibilityCertificateNumber
            || '';
          if (resolvedLOINumber && !this.LOI.LOINumber) {
            this.$set(this.LOI, 'LOINumber', resolvedLOINumber);
          }

          const resolvedLOIDate = this.LOI.LOIDate
            || this.LOI.LoiDate
            || this.LOI.LetterDate
            || this.LOI.IssueDate
            || this.LOI.ApprovedDate
            || this.LOI.ApprovalDate
            || this.LOI.CreatedDate
            || this.LOI.CreateDate
            || this.LOI.Createdate
            || this.LOI.GeneratedDate
            || this.LOI.GenerateDate
            || this.LOI.ApplicationDate
            || '';
          if (resolvedLOIDate && !this.LOI.LOIDate) {
            this.$set(this.LOI, 'LOIDate', resolvedLOIDate);
          }
          console.log('Resolved LOINumber:', resolvedLOINumber, '| Resolved LOIDate:', resolvedLOIDate);
          console.log('FULL LOI object after ReadLOI+resolve:', JSON.stringify(this.LOI));

          // If LOINumber/LOIDate still empty, try ReadApprovalRemarksLink as a
          // last-resort source — admin approval workflows often stamp LOI
          // metadata onto approval-remark rows.
          if ((!this.LOI.LOINumber || !this.LOI.LOIDate) && !this.tenantMode) {
            apis.ReadApprovalRemarksLink(this.effectiveApplicationID)
              .then(res => {
                if (res.status !== 200) return;
                const body = this.parseApiBody(res.body) || {};
                const rows = body.Table && body.Table.length
                  ? body.Table
                  : (Array.isArray(body) ? body : []);
                console.log('ApprovalRemarksLink rows count:', rows.length,
                  'first-row keys:', rows[0] ? Object.keys(rows[0]) : 'none');
                for (const r of rows) {
                  const num = r.LOINumber || r.LOINo || r.LetterNumber
                    || r.CertificateNo || r.CertificateNumber
                    || r.EligibilityCertificateNo;
                  const dt = r.LOIDate || r.LetterDate || r.IssueDate
                    || r.ApprovedDate || r.ApprovalDate
                    || r.CreatedDate || r.Createdate || r.CreateDate;
                  if (num && !this.LOI.LOINumber) {
                    this.$set(this.LOI, 'LOINumber', num);
                  }
                  if (dt && !this.LOI.LOIDate) {
                    this.$set(this.LOI, 'LOIDate', dt);
                  }
                  if (this.LOI.LOINumber && this.LOI.LOIDate) break;
                }
                console.log('After ApprovalRemarksLink — LOINumber:',
                  this.LOI.LOINumber, '| LOIDate:', this.LOI.LOIDate);
              })
              .catch(e => console.log('ReadApprovalRemarksLink error:', e));
          }

          if (!this.tenantMode) this.loadGroupLoiDetails().then(() => {
            if (!this.LOI.ApplicantName || !this.LOI.ApplicantName.trim()) {
              const fallbackName = this.LOI.Name
                || [this.LOI.FirstName, this.LOI.MiddleName, this.LOI.LastName].filter(p => p && p.trim()).join(' ')
                || this.LOI.GroupName
                || this.LOI.FullName
                || '';
              this.$set(this.LOI, 'ApplicantName', fallbackName.trim());
            }
          });
          // Use the correct portal URL
          this.qrtext = this.tenantMode ?
            verificationUrl(this.documentBranding, applicationId, this.LOI.LOINumber) :
            `https://portal.vnvjntdc.org/verifyloi/${applicationId}/${this.LOI.LOINumber}`;
          this.isLoading = false;

          const loiDate = this.processdate(this.LOI.LOIDate);
          const cutoffDate = this.processdate('01/01/2025');

          this.loidesignationlabel = loiDate < cutoffDate ? "महाव्यवस्थापक" : "व्यवस्थापकीय संचालक";

          if (this.tenantMode) {
            if (!this.LOI.ApplicantName || !this.LOI.LOIDate) {
              throw new Error("The issued LOI is missing required applicant or date information.");
            }
            if ([1, 2, 3].indexOf(Number(this.LOI.LoanType)) === -1) {
              throw new Error("The issued LOI is missing a valid loan type.");
            }
            this.documentReady = true;
            return;
          }

          // Fetch caste using UserID - try LOI response, then prop, then store (logged-in user)
          const emptyGuid = '00000000-0000-0000-0000-000000000000';
          const loiUserID = this.LOI.UserID || this.LOI.UserId || this.LOI.userID || this.LOI.userid || '';
          const propUserID = this.effectiveUserID || '';
          const storeUserID = (this.$store && this.$store.getters && this.$store.getters.loggedUser)
            ? (this.$store.getters.loggedUser.UserId || this.$store.getters.loggedUser.UserID || '')
            : '';
          const finalUserID = (loiUserID && loiUserID !== emptyGuid)
            ? loiUserID
            : (propUserID && propUserID !== emptyGuid)
              ? propUserID
              : (storeUserID && storeUserID !== emptyGuid ? storeUserID : null);

          console.log('LOI UserID:', loiUserID, '| Prop UserID:', propUserID, '| Store UserID:', storeUserID, '| Using:', finalUserID);

          // Load full caste list for reliable CasteID→CasteName lookup
          apis.getCaste().then(cr => {
            if (cr.status === 200) {
              const parsed = (typeof cr.body === 'string') ? JSON.parse(cr.body) : cr.body;
              this.casteList = Array.isArray(parsed) ? parsed : [];
              console.log('casteList loaded, count:', this.casteList.length);
              // Find this user's caste by CasteID
              if (this.LOI.CasteID) {
                const match = this.casteList.find(c => c.CasteID === this.LOI.CasteID);
                if (match) {
                  this.userCasteName = match.CasteName || '';
                  console.log('Caste found via CasteID:', this.userCasteName, '→', this.subDepartmentName);
                } else {
                  console.log('CasteID not found in caste list:', this.LOI.CasteID);
                }
              }
            }
          }).catch((e) => { console.log('getCaste error:', e); });

          if (finalUserID) {
            const isGroupLoan = String(this.effectiveLoanType) === '2';

            if (isGroupLoan) {
              // For group loans, use ReadUserDetailByGroup
              apis.ReadUserDetailByGroup(finalUserID)
                .then(res => {
                  if (res.status === 200) {
                    const body = this.parseApiBody(res.body) || {};
                    const details = body.Table && body.Table.length > 0
                      ? body.Table[0]
                      : (Array.isArray(body) && body.length > 0 ? body[0] : body);
                    console.log('ReadUserDetailByGroup response keys:', Object.keys(details));
                    // Apply group details as fallback for any missing LOI fields
                    this.applyGroupProfile(details);
                    const casteName = details.CasteName || details.Caste || details.casteName || details.caste || '';
                    if (casteName) {
                      this.userCasteName = casteName.normalize ? casteName.normalize('NFC') : casteName;
                      console.log('Group CasteName:', this.userCasteName);
                      this.$forceUpdate();
                    }
                    if (!this.LOI.CasteID && details.CasteID) {
                      this.$set(this.LOI, 'CasteID', details.CasteID);
                    }
                  }
                })
                .catch((e) => { console.log('ReadUserDetailByGroup error:', e); });
            }

            // Method 1: ReadUserDetailByIndivisual (ProfilePrinting API)
            apis.ReadUserDetailByIndivisual(finalUserID)
              .then(res => {
                if (res.status === 200) {
                  const details = (typeof res.body === 'string') ? JSON.parse(res.body) : res.body;
                  console.log('ReadUserDetailByIndivisual response keys:', Object.keys(details));
                  console.log('ReadUserDetailByIndivisual full response:', JSON.stringify(details).substring(0, 500));
                  const casteName = details.CasteName || details.Caste || details.casteName || details.caste || '';
                  if (casteName) {
                    this.userCasteName = casteName.normalize ? casteName.normalize('NFC') : casteName;
                    console.log('ProfilePrinting CasteName:', this.userCasteName, 'subDept:', this.subDepartmentName);
                    this.$forceUpdate();
                  }
                  // For group loans, also fill in missing fields from individual details
                  if (isGroupLoan) {
                    this.applyGroupProfile(details);
                  }
                }
              })
              .catch((e) => { console.log('ReadUserDetailByIndivisual error:', e); });

            // Method 2: ReadUserDetail (Registration API) as fallback
            apis.ReadUserDetail(finalUserID)
              .then(res => {
                if (res.status === 200) {
                  const details = (typeof res.body === 'string') ? JSON.parse(res.body) : res.body;
                  console.log('ReadUserDetail response keys:', Object.keys(details));
                  console.log('ReadUserDetail CasteName:', details.CasteName, 'CasteID:', details.CasteID);
                  const casteName = details.CasteName || details.Caste || details.casteName || details.caste || '';
                  if (casteName && !this.userCasteName) {
                    this.userCasteName = casteName.normalize ? casteName.normalize('NFC') : casteName;
                    console.log('Registration CasteName:', this.userCasteName, 'subDept:', this.subDepartmentName);
                    this.$forceUpdate();
                  }
                  // Also set CasteID from user details if LOI doesn't have it
                  if (!this.LOI.CasteID && details.CasteID) {
                    this.$set(this.LOI, 'CasteID', details.CasteID);
                  }
                }
              })
              .catch((e) => { console.log('ReadUserDetail error:', e); });
          } else {
            console.log('No valid UserID found - cannot fetch caste');
          }
        } else {
          const isGroupFallback = String(this.effectiveLoanType) === '2';
          if (isGroupFallback) {
            // For group loans: don't hard-error — try to populate LOI number/date
            // from ApprovalRemarksLink and the already-running loadGroupLoiDetails()
            apis.ReadApprovalRemarksLink(this.effectiveApplicationID)
              .then(res => {
                if (res.status !== 200) return;
                const body = this.parseApiBody(res.body) || {};
                const rows = body.Table && body.Table.length
                  ? body.Table
                  : (Array.isArray(body) ? body : []);
                console.log('[group-else] ApprovalRemarksLink rows:', rows.length,
                  'keys:', rows[0] ? Object.keys(rows[0]) : 'none');
                for (const r of rows) {
                  const num = r.LOINumber || r.LOINo || r.LetterNumber
                    || r.CertificateNo || r.CertificateNumber
                    || r.EligibilityCertificateNo || r.EligibilityCertificateNumber;
                  const dt = r.LOIDate || r.LetterDate || r.IssueDate
                    || r.ApprovedDate || r.ApprovalDate
                    || r.CreatedDate || r.Createdate || r.CreateDate;
                  if (num && !this.LOI.LOINumber) this.$set(this.LOI, 'LOINumber', num);
                  if (dt && !this.LOI.LOIDate) this.$set(this.LOI, 'LOIDate', dt);
                  if (this.LOI.LOINumber && this.LOI.LOIDate) break;
                }
                console.log('[group-else] After ApprovalRemarksLink — LOINumber:', this.LOI.LOINumber, '| LOIDate:', this.LOI.LOIDate);
              })
              .catch(e => console.log('[group-else] ReadApprovalRemarksLink error:', e));
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        }
      })
      .catch(err => {
        if (this.tenantMode) {
          if (brandingRequest !== this.brandingRequest) return;
          console.error("Tenant LOI lookup failed:", err);
          this.tenantError = "Unable to load this tenant's LOI. Please contact support.";
          this.isLoading = false;
          return;
        }
        console.log('ReadLOI error:', err && err.message ? err.message : err);
        if (String(this.effectiveLoanType) === '2') {
          // For group loans: silently fall back — try ApprovalRemarksLink for LOI number/date
          apis.ReadApprovalRemarksLink(this.effectiveApplicationID)
            .then(res => {
              if (res.status !== 200) return;
              const body = this.parseApiBody(res.body) || {};
              const rows = body.Table && body.Table.length
                ? body.Table
                : (Array.isArray(body) ? body : []);
              console.log('[group-catch] ApprovalRemarksLink rows:', rows.length);
              for (const r of rows) {
                const num = r.LOINumber || r.LOINo || r.LetterNumber
                  || r.CertificateNo || r.CertificateNumber
                  || r.EligibilityCertificateNo || r.EligibilityCertificateNumber;
                const dt = r.LOIDate || r.LetterDate || r.IssueDate
                  || r.ApprovedDate || r.ApprovalDate
                  || r.CreatedDate || r.Createdate || r.CreateDate;
                if (num && !this.LOI.LOINumber) this.$set(this.LOI, 'LOINumber', num);
                if (dt && !this.LOI.LOIDate) this.$set(this.LOI, 'LOIDate', dt);
                if (this.LOI.LOINumber && this.LOI.LOIDate) break;
              }
              console.log('[group-catch] After ApprovalRemarksLink — LOINumber:', this.LOI.LOINumber, '| LOIDate:', this.LOI.LOIDate);
            })
            .catch(e => console.log('[group-catch] ReadApprovalRemarksLink error:', e));
        } else {
          this.alertText = err && err.message ? err.message : 'Error loading LOI.';
          this.showDismissibleAlert = true;
          this.variant = "danger";
        }
        this.isLoading = false;
      });
    }
  },
  watch: {
    ApplicationID(newVal) {
      if (newVal) {
        this.loadData();
      }
    },
    '$route.params.LOINumber'() {
      if (this.tenantMode) this.loadData();
    }
  },
  mounted() {
    if (!this.effectiveApplicationID) {
      this.alertText = "Application ID not found for LOI.";
      this.showDismissibleAlert = true;
      this.variant = "warning";
      this.isLoading = false;
      return;
    }
    this.loadData();
  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}

.print-button-wrap button {
  color: #fff;
  background-color: #0A0032;
  font-size: 13px;
  font-weight: bold;
  border: none;
  padding: 8px 20px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
}

.print-button-wrap {
  margin: auto;
  width: fit-content;
  margin-top: 20px;
  margin-bottom: 30px;
}

.loi {
  margin-bottom: 50px;
  margin-top: 20px;
}

.loi,
.loi p {
  color: #000;
  font-size: 16px;
  font-family: "Laila", serif;
}

.tobold {
  font-weight: bold;
}

.loi h2 {
  font-size: 29px;
  text-align: center;
}

.loi h3 {
  font-size: 22px;
  text-align: center;
  margin-top: 7px;
  margin-bottom: 20px;
}

.loi .num-date {
  margin-top: 35px;
}

.loi .app-nm {
  display: inline-block;
  margin-right: 80px;
}

.loi .prati span {
  display: block;
}

.loi .prati {
  margin-top: 20px;
  margin-bottom: 20px;
}

.loi .priy {
  margin-top: 20px;
  margin-bottom: 25px;
}

.loi .vyav-s span {
  display: block;
  font-weight: bold;
}

.loi .ati {
  margin-top: 25px;
  margin-bottom: 25px;
}

.loi .ati h4 {
  font-size: 19px;
  font-weight: bold;
  margin-bottom: 17px;
}

.loi .ati p {
  margin-bottom: 13px;
}

.loi {
  width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 1199px) {
  .loi {
    width: 80%;
  }
}

@media (max-width: 767px) {
  .loi {
    width: 90%;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 15px;
  }

  .loi h2 {
    font-size: 24px;
  }

  .loi h3 {
    font-size: 20px;
  }

  .loi .ati h4 {
    font-size: 18px;
  }

  .loi .app-nm {
    margin-right: 0;
    display: block;
  }
}

@media print {
  body {
    margin: 0;
    padding: 0;
    font-size: 9pt !important;
  }

  #printLOI {
    margin: 0 !important;
    padding: 0 !important;
    transform: scale(0.85);
    transform-origin: top left;
    width: 117.6%;
  }

  .print-button-wrap {
    display: none;
  }

  div[style*="margin-left:40px"] {
    margin-left: 15px !important;
    margin-right: 5px !important;
    margin-top: 5px !important;
  }

  p {
    font-size: 9pt !important;
    line-height: 1.1 !important;
    margin-bottom: 1px !important;
    margin-top: 1px !important;
  }

  span {
    font-size: 9pt !important;
    line-height: 1.1 !important;
  }

  td {
    font-size: 9pt !important;
    line-height: 1.1 !important;
    padding: 3px !important;
  }

  table {
    font-size: 9pt !important;
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }

  div[style*="margin-top: 25px"],
  div[style*="margin-top: 20px"],
  div[style*="margin-top: 15px"] {
    margin-top: 5px !important;
    margin-bottom: 3px !important;
  }

  span[style*="font-size:17.0pt"] {
    font-size: 12pt !important;
  }

  span[style*="font-size:15.0pt"] {
    font-size: 11pt !important;
  }

  span[style*="font-size:14.0pt"] {
    font-size: 10pt !important;
  }

  span[style*="font-size:13.0pt"] {
    font-size: 10pt !important;
  }

  span[style*="font-size:12.0pt"] {
    font-size: 9pt !important;
  }

  p[style*="font-size: 17pt"] {
    font-size: 12pt !important;
    margin-bottom: 2px !important;
  }

  p[style*="font-size: 14pt"] {
    font-size: 11pt !important;
    margin-bottom: 2px !important;
  }

  .loi {
    page-break-inside: avoid;
  }

  br {
    line-height: 0.5 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/LoanLOIPrint.vue